import { defineComponent } from "vue";
export default defineComponent({
  props: {
    notice: {
      type: Object,
      required: true
    }
  }
});